import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
// @ts-ignore
import { Button } from '@els/els-react--button';
// @ts-ignore
import connectionError from '../../assets/img/connection-error.svg';
import routes from '../../constants/routes';
import './server-error-page.scss';
import { selectEcrId } from '../../features/login/login-selector';

const ServerErrorPage = () => {
    const baseClassName = 'server-error-page';
    const ecrId = useSelector(selectEcrId);
    const history = useHistory();
    const navigateBackToReports = () => {
        history.push(routes.HOME.replace(':ecrId', ecrId));
    };

    return (
        <div className={`${baseClassName}`}>
            <div className={`${baseClassName}__container`}>
                <div className={`${baseClassName}__container-image`}>
                    <img
                        id="connection-error-logo"
                        src={connectionError}
                        alt="Connection Error Logo"
                    />
                </div>
                <div className={`${baseClassName}__container_content`}>
                    <div
                        className={`${baseClassName}__container_content-title`}
                    >
                        Connection error
                    </div>
                    <p
                        className={`${baseClassName}__container_content-message`}
                    >
                        Please check your network and try again.
                    </p>
                    <Button onClick={navigateBackToReports} type="primary">
                        Go back
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ServerErrorPage;
